import React from 'react';
import { RaisedButton } from 'material-ui';
import { connect } from 'react-redux';

const GetVerified = ({ getVerified, tcVerified }) => {
  if (tcVerified) return null;
  return (
    <RaisedButton
      label="Get Verified"
      backgroundColor="#F881B2"
      labelStyle={{
        color: 'white',
        fontSize: '1em',
        textTransform: 'none',
        fontWeight: 'bold',
      }}
      onTouchTap={() => {
        getVerified();
      }}
    />
  );
};

module.exports = connect(({ user }) => ({
  tcVerified: user.getIn(['company', 'tcVerified']),
}), {
  getVerified: () => dispatch =>
    dispatch({ type: '{profile} getVerified' })
  ,
})(GetVerified);




// WEBPACK FOOTER //
// ./src/app/components/get-verified.jsx